/**
 * gestisce tutte le fasi del caricamento di una immagine
 * mostra il pulsante scegli, la preview, fa i controlli sul file  e le chiamate API del caso
 * 
 * sostituisce il componente ImageUpload
 * 
 * 2024/02/15 : aggiunto alla chiamata save_athlete_photo() la gestione se il server risponde con un errore 
 *              quando si caricano le immagini: viene visualizzato un popup (toast) di alert e cambia la colorazione del blocco
 * 
 */

import React from "react";

// used for making the prop types of this component
import PropTypes from "prop-types";

// import GridContainer from "../../components/Grid/GridContainer";
// import ItemGrid from "../../components/Grid/ItemGrid";
// import {Card} from "material-ui";

import Snackbar from '../../components/Snackbar/Snackbar';
import AddPhoto from "@material-ui/icons/AddAPhoto";


import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
// import DialogContentText from '@mui/material/DialogContentText';

import CircularProgress from "material-ui/Progress/CircularProgress";

// core components
import Button from "../CustomButtons/Button.jsx";

import Check from "@material-ui/icons/Check";
import CameraAlt from "@material-ui/icons/CameraAlt";
import Folder from "@material-ui/icons/Folder";


import {inject, observer} from "mobx-react";
import {toJS} from "mobx";
import {v4 as uuidv4} from "uuid";

import {
    landing_page_max_photo_size,
    landing_page_min_photo_size,
    isProduction
} from "../../utils/constants";


import './PhotoUpload.css';

@inject('store')
@observer


class PhotoUpload extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            file: null,
            imagePreviewUrl: null,
            showImagePreview: false,
            showCircularProgress: false,

            //  imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
            // text_upload_photo: props.text_upload_photo,
            
            photoID : props.photoID,
            
            errors: {},
            formIsValid: true,
            
            ProjectID: null,
            TeamID : props.TeamID,
            
            athlete: {
                name: props.athleteName,
                lastname: props.athleteLastname,
                team: null,
                category: null,
                photo: null,
                is_referent: false,
                referent_mail: '',
                ProjectID: null,
                photoID: null,
                name_lastname: null,
                teamID: null,
                categoryID: null
            },
            showUploadDialog: false,
            showUploadAlert: false,
            showMsgUploadAlert: false,
            classUploadError: ''
        };

        // la struttura dei dati per i singoli atleti che arrivano dalla athleteList 
        this.athlete = props.athlete;
        
        this.store = this.props.store.appState;
        
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleRemove = this.handleRemove.bind(this);

    }


    /**
     * azzera gli errori
     */
    componentWillMount() {
        let errors = {};
        errors['photo'] = false;
        this.setState({errors: errors});

    }

    
    /**
     * evento onClick sul bottone "scegli"
     * carica la foto e prepara i dati per l'ivio al serve con la funzione handleSubmit()
     * 
     * @param {*} e 
     */
    handleImageChange(e) {

        e.preventDefault();
        try {

            let reader = new FileReader();
            let file = e.target.files[0];

            reader.onloadend = () => {

                const photo_unique_token = uuidv4();
            
                this.setState({
                    file: file,
                    imagePreviewUrl: URL.createObjectURL(file),
                    showImagePreview: false,
                    classUploadError: '',
                    showCircularProgress: true,
                    showMsgUploadAlert: false,
                    errors: {}
                });

                // carico il file con FileReader
                let fileName = file.name.split(".");
                let ext = fileName.pop();
                let firstVal = fileName.join(".");
                let updatedFileName = firstVal +'_'+ photo_unique_token + '.' + ext;
                let newFile = new File([file], updatedFileName) ;

                this.handleSubmit(newFile);
                
            };

            reader.readAsDataURL(file);

        }catch (error) {
            // console.log(" handleImageChange : error : ", error );
        }
    }


    /**
     * controllo sui dati prima dell'invio alle API
     * 
     * @returns 
     */
    
    handleFormValidation(){
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        
        const athlete = this.athlete;

        let errors = {};
        let formIsValid = true;
        
        // empty name
        if (!athlete.name.trim()) {
            formIsValid = false;
            errors["NomeCognome"] = DEFAULT_TEXT.error_empty_name;
        }

        //empty Lastname
        if (!athlete.lastname.trim()) {
            formIsValid = false;
            errors["NomeCognome"] = DEFAULT_TEXT.error_empty_lastname;
        }
        
        // se non c'è il file caricato
        if (this.store.file === null) {
            errors['photo'] = true;
            errors['error_preview'] = true;
            formIsValid = false;
        }

        // dimensioni del file: ne troppo piccolo, ne troppo grande
        // if( isProduction ) {
            if (this.store.file_size > landing_page_max_photo_size || this.store.file_size < landing_page_min_photo_size) {
                errors['error_file_size'] = true;
                errors['error_preview'] = true;
                formIsValid = false;
            }
        // }

        // just for test: segnala l'errore sul file ma non blocca il processo
        // formIsValid = true;

        this.setState({errors: errors, formIsValid: formIsValid});

        return formIsValid;

    }

    
    /**
     * faccio la chiamata API per invio del file al server
     * e se va bene salvo i dati in this.store.photo_uploaded
     * 
     * @param {*} newFile 
     */
    handleSubmit(newFile) {

        // salvo le info in this.store che poi uso quando farò l'invio del form da UploadPhotoRefactored
        this.store.file = newFile;
        this.store.file_name = newFile.name;
        this.store.file_size = newFile.size;
       
        const { TeamID} = this.state;
        const athlete = this.athlete;

        if (this.handleFormValidation()) {

            athlete['upload_date'] = this.stringifyDateTime();

            athlete.is_referent = Number(athlete.is_referent);
            athlete.fileToUpload = this.store.file; // -> fileToUpload
            athlete.photo_file_name = this.store.file_name
            athlete.photo_file_size = this.store.file_size

            if (athlete.photoID === null) {
                athlete.photoID = '';
            }
            if (athlete.teamID === null) {
                // athleteData.TeamID = this.state.projectData[0].TeamID;
                athlete.teamID = TeamID;
            }

            const self = this;

            // fa la chiamata APi alla url '/photoselfie/save_athlete_data/' passandogli i dati del form
            // sostituisce la parte di file della chiamata save_athlete_data
            this.store.save_athlete_photo(athlete, function (res) {
            
                if (res.success === true) {
                    self.store.photo_uploaded.push(athlete);
                    self.setState({
                        showUploadDialog: true,
                        classUploadError: 'upl-success',
                        showImagePreview: true,
                        showCircularProgress: false,
                        
                    });

                    // self.showNotification('dialog');
            
                } else {
                    // alert('result is false');

                    // self.showNotification("alert");

                    const errors = {};
                    errors['error_preview'] = true

                    self.setState({
                        errors: errors,
                        showUploadAlert: true,
                        file: null,
                        // imagePreviewUrl: '',
                        classUploadError: 'upl-warning',
                        showImagePreview: true,
                        showCircularProgress: false,
                        showMsgUploadAlert: true,
                    });

                }
            
            });

        } else {

            this.setState({
                classUploadError: 'upl-warning',
                showImagePreview: true,
                showCircularProgress: false
            });

        }
        
    }

    showNotification(item) {

        switch (item) {
            case 'dialog' : this.setState({showUploadDialog: true});
            break;
            case 'alert' : this.setState({showUploadAlert: true});
        }
        
    }

    /**
     * evento onClik sul pulsante remove
     * elimina i dati del file dalla lista this.store.photo_uploaded
     * NB: non è prevista una API per cancellare il file dal server
     * 
     */
    handleRemove() {
        
        const {photoID } = this.state;

        let errors = {};
        let formIsValid = true;
        this.setState({
            errors: errors, 
            formIsValid: formIsValid, 
            file: null,
            imagePreviewUrl: null,
            showImagePreview: false
        });
        
        // this.setState({file: null,imagePreviewUrl: null});
        this.store.file = null;
        
        this.store.photo_uploaded = this.store.photo_uploaded.filter( (item) => {
            return item.photoID !== photoID;
        })

    }


    /**
     * restituisce una stringa con data e ora corrrente
     * 
     * @returns 
     */
    stringifyDateTime = () => {

        let date_ob = new Date();

        let date = ("0" + date_ob.getDate()).slice(-2);
        let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
        let year = date_ob.getFullYear();
        let hours = date_ob.getHours();
        let minutes = date_ob.getMinutes();
        let seconds = date_ob.getSeconds();

        return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
        
    }

    // handleClickOpen = () => {
    //     this.setState({showUploadDialog: true, tc: true});
    // }

    handleClose = (button) => {
        if(button === true ){
            this.setState({showUploadDialog: false});
        } 

        if(button === false ){
            // trovare un modo per eseguire la saveAthleteData()
            this.setState({showUploadDialog: false});
        }

        if(button === 'alert'){
            this.setState({showUploadAlert: false});
        }
    }


    render() {

        let RenderHTML = (props) => (<span dangerouslySetInnerHTML={{__html:props.HTML}}></span>)

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        const {
            errors,
            photoID
        } = this.state;

        const athlete = this.athlete;

        // let shoot_button = DEFAULT_TEXT.shoot_button.toUpperCase();
        let shoot_button_1 = DEFAULT_TEXT.shoot_button_1.toUpperCase();
        let shoot_button_2 = DEFAULT_TEXT.shoot_button_2.toUpperCase();

        // let choosetext = DEFAULT_TEXT.shoot_button.toUpperCase();
        // if(DEFAULT_TEXT.shoot_button!==undefined){
        //     choosetext=DEFAULT_TEXT.shoot_button.toUpperCase();
        // }

        const id= "photo-upload-"+photoID;
        
        const idimg= "image-upload-"+photoID;
        const idimg_cam= "image-camera-"+photoID;
        const idimg_upl= "image-upload-"+photoID;

        return (

            <div className="upload-photo-wrp">
                <div id={id}  className={'upload-container ' + this.state.classUploadError} >

                    <div className="label-wrapper">
                        <label
                            className={this.state.file === null && errors['photo'] ? 'label-red fontRoboto' : 'label fontRoboto'} 
                        >
                            {DEFAULT_TEXT.take_upload_photo} 
                            <br />
                            {athlete.NomeCognome}<span style={{color: "red", marginLeft: '0.2rem'}}>*</span>
                        </label>
                    </div>

                    <div className="input-photo" >
                        <div className="photo-wrp" >

                            {/* {this.state.showImagePreview && (                     */}
                            {this.state.file && (
                                <div className={"thumbnail preview " + (this.props.avatar ? " img-circle" : "")  + (errors['error_preview'] ? " preview-error " : "")} >
                                    
                                    {this.state.showCircularProgress && (
                                        <span><CircularProgress style={{ color: '#9C27B0', width: '32px'}}/></span>
                                    )}
                                    
                                    {this.state.showImagePreview && (
                                        <span><img className="image-preview" src={this.state.imagePreviewUrl} alt={'preview'}/></span>
                                    )}
                                </div>
                            )}
                        </div>

                        <div
                            className="wrapper-button">
                                        
                                {this.state.file === null
                                    ?
                                    (
                                        
                                        <span className="">
                                            
                                            <div 
                                                className="button button-load" 
                                            >
                                                <label htmlFor={idimg_cam} className="label-icon-flex" ><CameraAlt className="icon-label-photo" /><span>{shoot_button_1}</span></label>
                                                <input id={idimg_cam} type="file" accept="image/*" onChange={(e) => { this.handleImageChange(e)} } style={{display:'none'}} capture="environment" />
                                            </div>

                                            <div 
                                                className="button button-load" 
                                            >
                                                <label htmlFor={idimg_upl} className="label-icon-flex" ><Folder className="icon-label-photo" />{shoot_button_2}</label>
                                                <input id={idimg_upl} type="file" accept="image/*" onChange={(e) => { this.handleImageChange(e)} } style={{display:'none'}} />
                                            </div>
                                        </span>
                                    )
                                    :
                                    (
                                        <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                            <Button round color="danger" style={{height: '2rem',width:'5rem'}} onClick={() => this.handleRemove()}> {DEFAULT_TEXT.remove_label} </Button>
                                        </span>
                                    )
                                }

                                {this.state.showMsgUploadAlert && (
                                    <p className={"info-max-size fontRoboto  info-max-size-error "} >{DEFAULT_TEXT.upload_error_server}</p>
                                )}
                                <p className={"info-max-size fontRoboto " + (errors['error_file_size'] ? " info-max-size-error " : "")} >{DEFAULT_TEXT.max_file_size}</p>
                                
                        </div>
                    
                    </div>
                </div>


                <div>                    
                    <Dialog
                        open={this.state.showUploadDialog}
                        onClose={() => this.handleClose()}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"DEFAULT_TEXT.dialog_image_uploaded"}
                        </DialogTitle>
                        <DialogContent>
                            <div id="alert-dialog-description">
                            <p>{DEFAULT_TEXT.dialog_image_uploaded_msg_1}</p>
                            <p><b>{DEFAULT_TEXT.dialog_image_uploaded_msg_2}</b></p>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleClose(false)} autoFocus>{DEFAULT_TEXT.btn_close}</Button>
                            <Button onClick={() => this.handleClose(true)}>{DEFAULT_TEXT.btn_ok}</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                

                {true && (
                    <Snackbar
                        place="tc"
                        color="danger"
                        icon={AddPhoto}
                        message={DEFAULT_TEXT.uploadFailed}
                        open={this.state.showUploadAlert}
                        closeNotification={() => this.handleClose('alert')}
                        close
                    />
                )}


            </div>
        );
    }
}

PhotoUpload.propTypes = {
    avatar: PropTypes.bool
};

export default PhotoUpload;




// WEBPACK FOOTER //
// ./src/components/CustomUpload/PhotoUpload.jsx